<template>
  <div class="main-page">
    <div class="container-fluid px-0">
      <aside class="d-md-none">
        <app-bar title="Login" previousLink="/" />
      </aside>
      <div class="row g-0">
        <div class="col-md-5 d-flex align-items-md-center px-3 px-md-0">
          <div class="form-login w-100">
            <div class="text-center mb-4">
              <router-link to="/">
                <img src="/img/logo.png" alt="Logo Parahita" style="height: 90px;" />
              </router-link>
            </div>
            <div class="group-title mb-4 text-center">
              <span class="title-content-package fw-normal">Masuk ke Akun Anda</span> <br />
              <span class="fw-normal fs-12 color-neutral-600">
                Silahkan pilih metode masuk
              </span>
            </div>

            <div class="w-full d-flex justify-content-between gap-3 mb-3">
              <div
                class="rounded-pill px-3 py-2 w-50 text-center cursor-pointer"
                :class="{
                  'bg-primary text-white': loginType === 'phone',
                  'border border-2 border-primary text-primary':
                    loginType !== 'phone'
                }"
                @click="changeType('phone')"
              >
                Nomor HP
              </div>
              <div
                class="rounded-pill px-3 py-2 w-50 text-center cursor-pointer"
                :class="{
                  'bg-primary text-white': loginType === 'email',
                  'border border-2 border-primary text-primary':
                    loginType !== 'email'
                }"
                @click="changeType('email')"
              >
                Email
              </div>
            </div>

            <div v-if="loginType === 'email'">
              <div class="card login-card">
              <Form @submit="isLogin" v-slot="{ errors }">
                <label class="fw-bold">Email</label>
                <div class="input-group mb-3">
                  <Field
                    type="email"
                    v-model="email"
                    name="email"
                    rules="required"
                    class="form-control"
                    :class="{ 'is-invalid': errors.email || errorMessage }"
                    :disabled="loading.login"
                    placeholder="Cth: nama@email.com"
                  />
                  <span
                    class="input-group-text bg-grayscale border-0"
                    :class="{ 'is-invalid': errors.email || errorMessage }"
                  >
                    <div
                      class="show-password"
                      type="button"
                      @click="email = ''"
                      :class="{ 'opacity-0': !email }"
                    >
                      <i class="ri-close-circle-fill fs-24"></i>
                    </div>
                  </span>
                  <span v-if="!errors.email" class="invalid-feedback">{{
                    errorMessage
                  }}</span>
                  <ErrorMessage name="email" class="invalid-feedback" />
                </div>
                <label class="fw-bold">Kata Sandi</label>
                <div class="input-group mb-3">
                  <Field
                    v-model="password"
                    :type="type"
                    name="password"
                    class="form-control"
                    :class="{ 'is-invalid': errors.password || errorMessage }"
                    id="password-visibility"
                    rules="required"
                    :disabled="loading.login"
                    placeholder="Kata Sandi"
                  />
                  <span
                    class="input-group-text bg-grayscale border-0"
                    :class="{ 'is-invalid': errors.password || errorMessage }"
                  >
                    <div
                      class="show-password"
                      type="button"
                      @click="type = showPassword(type)"
                      :class="{ 'opacity-0': !password }"
                    >
                      <i
                        class="ri-eye-fill fs-24"
                        v-if="type === 'password'"
                      ></i>
                      <i
                        class="ri-eye-off-fill fs-24"
                        v-if="type === 'text'"
                      ></i>
                    </div>
                  </span>
                  <span v-if="!errors.password" class="invalid-feedback">{{
                    errorMessage
                  }}</span>
                  <ErrorMessage name="password" class="invalid-feedback" />
                </div>
                <button
                  type="submit"
                  class="btn btn-primary w-100 btn-login p-md-3"
                  :disabled="
                    !email ||
                    !password ||
                    Object.keys(errors).length ||
                    loading.login
                  "
                >
                  <p class="fst-normal fw-600 mb-0">
                    {{ loading.login ? 'Proses Masuk..' : 'Masuk' }}
                  </p>
                </button>
              </Form>
              </div>

              <div class="d-flex justify-content-center px-2 my-3">
                <router-link to="/login/forgot-password">
                  <span class="fw-bold color-secondary-500"
                    >Lupa Kata Sandi?</span
                  >
                </router-link>
              </div>
              <div
                class="d-flex justify-content-center my-3"
              >
                <p class="fw-normal color-neutral-600">
                  Belum punya akun?
                  <router-link to="/register">
                    <span class="fw-bold">Daftar Disini</span>
                  </router-link>
                </p>
              </div>
            </div>

            <div v-else>
              <div class="card login-card mb-3">
                <p class="fw-bold mb-1 fs-14">Login cepat via WhatsApp</p>
                <p class="text-muted mb-3 fs-12">Klik tombol di bawah, Anda akan diarahkan ke WhatsApp</p>
                <button
                  type="button"
                  class="btn w-100 text-white fw-600 btn-whatsapp"
                  :disabled="loading.waLogin || loading.login"
                  @click="isLoginByWhatsapp"
                >
                  <span class="d-flex align-items-center justify-content-center gap-2">
                    <i class="ri-whatsapp-line" style="font-size: 28px; line-height: 1;"></i>
                    <span>{{ loading.waLogin ? 'Mengarahkan...' : 'Masuk via WhatsApp' }}</span>
                  </span>
                </button>
              </div>
              <div class="card login-card">
                <Form @submit="isLoginByPhone" v-slot="{ errors }">
                  <label class="fw-bold">Nomor WhatsApp</label>
                  <div class="input-group w-full mb-3">
                    <VueTelInput
                      :value="phone"
                      v-model="phone"
                      name="phone"
                      rules="required"
                      mode="international"
                      class="form-control"
                      :class="{ 'is-invalid': errors.phone }"
                      :inputOptions="{
                        placeholder: '8xxx xxxx xxxx'
                      }"
                      :validCharactersOnly="true"
                      @input="phone"
                    />
                    <span
                      class="input-group-text bg-grayscale border-0"
                      :class="{ 'is-invalid': errors.phone || errorMessage }"
                    >
                      <div
                        class="show-password"
                        :class="{ 'opacity-0': !phone }"
                        type="button"
                        @click="phone = ''"
                      >
                        <i class="ri-close-circle-fill fs-24"></i>
                      </div>
                    </span>
                    <span v-if="!errors.phone" class="invalid-feedback">{{
                      errorMessage
                    }}</span>
                    <ErrorMessage name="phone" class="invalid-feedback" />
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary w-100 btn-login p-md-3"
                    :disabled="
                      !phone || Object.keys(errors).length || loading.login || loading.waLogin
                    "
                  >
                    <p class="fst-normal fw-600 mb-0">
                      {{ loading.login ? 'Proses Masuk..' : 'Kirim Kode OTP' }}
                    </p>
                  </button>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div class="d-none d-md-block col-md-7">
          <div
            class="frame-image vh-md-100 d-flex align-items-center justify-content-center"
          >
            <div>
              <img src="@/assets/illustration.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, Form, ErrorMessage } from 'vee-validate'
import { showPassword, login, loginByPhone, generateWaLogin, loading } from '@/core/auth'
import { title } from '@/core/page'
import { nextTick, onMounted, ref } from 'vue'
import AppBar from '@/components/AppBar.vue'
import { showNotif } from '@/core/utility'
import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

export default {
  components: {
    Form,
    Field,
    ErrorMessage,
    AppBar,
    VueTelInput
  },
  setup: () => {
    const loginType = ref('phone')
    const type = ref('password')
    const email = ref('')
    const password = ref('')
    const phone = ref('')
    const errorMessage = ref('')
    const bindProps = ref({
      mode: 'international',
      defaultCountry: 'ID',
      onlyCountries: ['ID'],
      enabledCountryCode: true,
      enabledFlags: true,
      autocomplete: 'off',
      required: true
    })

    const changeType = (param) => {
      loginType.value = param
      email.value = ''
      phone.value = ''
      password.value = ''
    }

    onMounted(() => {
      nextTick(() => {
        title.value = 'Login'
      })
    })

    return {
      loading,
      email,
      password,
      phone,
      type,
      errorMessage,
      showPassword,
      login,
      loginByPhone,
      generateWaLogin,
      loginType,
      bindProps,
      changeType
    }
  },
  methods: {
    async isLogin () {
      try {
        const { status, message } = await this.login({
          email: this.email,
          password: this.password,
          token_login: null // sementara null aja dulu
        })

        // Jika sukses
        if (status) {
          // Redirect ke halaman tujuan
          if (this.$route.redirectedFrom) {
            return this.$router.push({
              name: this.$route.redirectedFrom.name,
              params: this.$route.redirectedFrom.params
            })
          } else {
            // redirect ke home
            return this.$router.push({ name: 'Home' })
          }
        }

        this.errorMessage = message
      } catch (error) {
        this.errorMessage = error.response.data.message
      }
    },

    async isLoginByWhatsapp () {
      await this.generateWaLogin()
    },

    async isLoginByPhone () {
      try {
        if (this.phone.length < 10) {
          showNotif({
            status: 'error',
            message: 'Nomor telepon tidak valid.'
          })
        } else {
          const { status, message } = await this.loginByPhone({
            phone: this.phone.replace('+62', '0').replace(/\s/g, '')
          })

          if (status) {
            this.$router.push({
              name: 'OtpPhone',
              params: {
                phone: this.phone.replace('+62', '0').replace(/\s/g, '')
              }
            })
          } else {
            showNotif({
              status: 'error',
              message: message
            })
          }
        }
      } catch (error) {
        this.errorMessage = error.response.data.message
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-login {
  @media (min-width: 768px) {
    padding-top: 0;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 480px;
    margin: 0 auto;
  }
}

.form-control.is-invalid,
.input-group-text.is-invalid {
  box-shadow: inset 0px -1px 0px #e21f39;
}

.form-control::placeholder {
  color: #cbd5e0;
}

.form-control,
.input-group-text {
  background: none;
  border-radius: 0;
  box-shadow: inset 0px -1px 0px rgba(242, 242, 242, 0.8);
  padding: 8px 4px 8px 0px;
  font-size: 18px;
}

.btn-login {
  border: none;
  padding: 10px 20px;
}

.input-group > .form-control.form-error {
  background: #ffddeb;
  color: #14142b;
}

.frame-image {
  background: #007a9826;
  width: 100%;
  height: 100%;
}

// .frame-image img {
//     width: 90%;
//     height: auto;
// }

.form-control,
.input-group-text {
  background: none;
  border-radius: 0;
  box-shadow: inset 0px -1px 0px rgba(242, 242, 242, 0.8);
  padding: 8px 4px 8px 0px;
  font-size: 18px;
}

.vue-tel-input {
  border: none;
}

.login-card {
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;

  label {
    font-size: 14px;
    color: #14142b;
  }
}

.btn-whatsapp {
  background-color: #25D366;
  border: none;
  padding: 10px 20px;
  min-height: 53px;

  &:hover {
    background-color: #1ebe5d;
  }

  &:disabled {
    background-color: #25D366;
    opacity: 0.65;
  }
}

@media (min-width: 360px) and (max-width: 767px) {
  .frame-image {
    position: relative;
    background: #007a9826;
    width: 100%;
  }
}
</style>
